import angular from 'angular';
import scrollToBottom from './scroll-to-bottom.directive';

export default angular
  .module('hireApp.scroll-to-bottom', [])
  .directive('scrollToBottom', scrollToBottom)
  .name;



// WEBPACK FOOTER //
// ./client/components/scroll-to-bottom/index.js